import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { ParallaxBackground } from '../ParallaxBackground';
export function BuiltForRealtors() {
  const benefits = ['Volume pricing for active agents', 'Direct text line to your dedicated coordinator', 'Net 15 invoicing on closed transactions', 'Recurring vacant home maintenance available'];
  return <section className="relative py-24 md:py-32 flex items-center min-h-[80vh]" data-id="element-31">
      <ParallaxBackground imageUrl="https://cdn.magicpatterns.com/uploads/7edMHcmVxv33AtEZGAfQxx/vita-vilcina-KtOid0FLjqU-unsplash.jpg" overlayOpacity={0.75} data-id="element-32" />

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-33">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-34">
          {/* Left Column - Copy */}
          <div data-id="element-35">
            <h2 className="text-white font-extrabold text-3xl md:text-5xl tracking-tight mb-6 leading-tight" data-id="element-36">
              We Don't Work With Homeowners. Just Realtors.
            </h2>
            <p className="text-white/90 text-lg md:text-xl leading-relaxed font-medium" data-id="element-37">
              Apex was built for the agent who needs a partner, not another
              vendor to manage. We invoice clean, communicate fast, and treat
              your listing like it's our own.
            </p>
          </div>

          {/* Right Column - Card */}
          <div className="bg-white rounded-md p-8 md:p-10 shadow-2xl" data-id="element-38">
            <h3 className="text-xl font-bold text-apex-charcoal mb-6" data-id="element-39">
              Partner Benefits
            </h3>
            <ul className="space-y-5 mb-8" data-id="element-40">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-41">
                  <CheckCircle2 className="w-6 h-6 text-apex-green shrink-0 mt-0.5" data-id="element-42" />
                  <span className="text-apex-charcoal font-medium" data-id="element-43">
                    {benefit}
                  </span>
                </li>)}
            </ul>
            <a href="#partner" className="block w-full bg-apex-green hover:bg-green-600 text-white text-center px-6 py-4 rounded-md font-bold text-lg transition-all shadow-sm hover:shadow-md min-h-[48px]" data-id="element-44">
              Become An Apex Partner
            </a>
          </div>
        </div>
      </div>
    </section>;
}